import BaseModel from '../base/BaseModel.model';
export default class CertificactionDocument extends BaseModel {
    public documentId?: number;
    public certificationUserId?: number;
    public document: any;
  
    constructor(){
        super();

        this.init();
    }

    init(){ 
        this.documentId = undefined;
        this.certificationUserId =undefined;
        this.email = "";
        this.isPhone = false;

        
    }
}